
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'PaginationLinkComponent',
    props: {
        pageLink: {
            type: Number,
            required: true
        },
        to: {
          type: Object,
          required: true
        }
    }
})
